import { Component, Input } from "@angular/core";

@Component({
  selector: "app-status-indicator",
  templateUrl: "./status-indicator.component.html",
  styleUrls: ["./status-indicator.component.css"],
})
export class StatusIndicatorComponent {
  @Input() status: string = "shipped"; // Set default value
  statusName: string;
  constructor() {}

  isComplete() {
    if (this.status === "delivered") {
      return (this.statusName = "Completed");
    } else if (this.status === "Payment completed") {
      return (this.statusName = "Payment Completed");
    }
  }

  inTransit() {
    if (this.status === "in_transit") {
      return (this.statusName = "In Transit");
    }
  }

  isShipped() {
    if (this.status === "shipped" || this.status === null) {
      return (this.statusName = "Shipped");
    }
  }

  isDue() {
    if (this.status === "Payment due") {
      return (this.statusName = "Payment Incomplete");
    }
  }
}
